import { useEffect, useState } from 'react';

/** Short successful requests never flash a status notice. Errors appear immediately. */
export function useDelayedStatus<T>(status: T | null, delay = 3000): T | null {
    const [visible, setVisible] = useState<T | null>(null);
    useEffect(() => {
        setVisible(null);
        if (status === null) return;
        const timer = setTimeout(() => setVisible(() => status), delay);
        return () => clearTimeout(timer);
    }, [status, delay]);
    return status === visible ? visible : null;
}
